import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';
dayjs.extend(utc);
dayjs.extend(timezone);
export const getConfigurationInitialState = () => ({
    organizationId: '',
    accessToken: '',
    search: {
        locale: 'en-US',
        timezone: dayjs.tz.guess(),
        authenticationProviders: [],
    },
    analytics: {
        enabled: true,
        originContext: 'Search',
        originLevel2: 'default',
        originLevel3: 'default',
        anonymous: false,
        deviceId: '',
        userDisplayName: '',
        documentLocation: '',
        analyticsMode: 'next',
        source: {},
    },
    knowledge: {
        answerConfigurationId: '',
    },
    environment: 'prod',
});
